var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contaier"},[_vm._v("页面走丢了~ 请返回重试！")])}
var staticRenderFns = []

export { render, staticRenderFns }